import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular/lazy';

/**
 * Modal que pide el email al usuario de la tienda cuando no tiene uno guardado.
 * Se cierra con role 'confirm' y el email como data (Aceptar) o con role 'cancel' (Cerrar).
 * Abrir mediante StoreEmailPromptService.
 */
@Component({
  selector: 'app-store-email-modal',
  templateUrl: 'store-email-modal.component.html',
  styleUrls: ['store-email-modal.component.scss'],
  standalone: false
})
export class StoreEmailModalComponent {
  email = '';

  constructor(private modalCtrl: ModalController) {}

  get isValid(): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((this.email || '').trim());
  }

  accept() {
    if (!this.isValid) return;
    this.modalCtrl.dismiss(this.email.trim(), 'confirm');
  }

  close() {
    this.modalCtrl.dismiss(null, 'cancel');
  }
}
